import {
    IRequestPersonnelDetailAction,
    ActionTypes,
    IReceivePersonnelDetailAction,
    ISetPersonnelDetailClearStateAction
} from './PersonnelDetail.action-types';
import { IPersonnelDetailRequest, IPersonnelDetailState } from './PersonnelDetail.types';

export const requestPersonnelDetail = (data?: IPersonnelDetailRequest): IRequestPersonnelDetailAction => {
    const type = ActionTypes.PERSONNELDETAIL_REQUEST;
    return {
        type,
        data
    };
};

export const receivePersonnelDetail = (
    data: IPersonnelDetailState,
    success: boolean,
    message: string
): IReceivePersonnelDetailAction => {
    const type = success ? ActionTypes.PERSONNELDETAIL_SUCCEEDED : ActionTypes.PERSONNELDETAIL_FAILED;
    return {
        type,
        data,
        message
    };
};

export const setPersonnelDetailClearState = (data: boolean): ISetPersonnelDetailClearStateAction => ({
    type: ActionTypes.PERSONNELDETAIL_SET_CLEARSTATE,
    data
});
